import React from 'react';
import AppWrapper from 'AppWrapper';
import AppWrapperV2 from 'AppWrapperV2';
import { isZywaveUrl } from 'lib/AppHelpers';
import AppConfig from 'appConfig';

export default function AppToggle() {
  return AppConfig.enableRedirectZywaveDotCom && isZywaveUrl() ? <AppWrapperV2 /> : <AppWrapper />;
}
